import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Select from './Select'
import { clearMovementReasons, getAllMovementReasons } from '../../../../actions'

const MovementReasonSelect = ({
  dispatchClearMovementReasons,
  options,
  loading,
  dispatchGetAllMovementReasons,
  isBoarding,
  isLeaving,
  ...rest
}) => {

  useLayoutEffect(() => {
    dispatchGetAllMovementReasons({
      isBoarding,
      isLeaving,
    })

    return () => {
      dispatchClearMovementReasons()
    }

  }, [])

  const filterOption = (motives) => motives

  return (
    <Select
      isLoading={loading}
      options={options}
      filterOption={filterOption}
      {...rest}
    />
  )
}

MovementReasonSelect.propTypes = {
  dispatchClearMovementReasons: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetAllMovementReasons: PropTypes.func.isRequired,
  isBoarding: PropTypes.bool,
  isLeaving: PropTypes.bool,
}

MovementReasonSelect.defaultProps = {
  isBoarding: null,
  isLeaving: null,
}

const mapStateToProps = ({ ItineraryUnit }) => ({
  options: ItineraryUnit.BoardingDraft.getIn(['movementReasons', 'content', 'content']).map(motive => ({
    value: motive.id,
    label: motive.description,
  })),
  loading: ItineraryUnit.BoardingDraft.getIn(['movementReasons', 'loading']),
})

const mapDispatchToProps = {
  dispatchClearMovementReasons: clearMovementReasons,
  dispatchGetAllMovementReasons: getAllMovementReasons,
}


export default connect(mapStateToProps, mapDispatchToProps)(MovementReasonSelect)
